import { render } from "./IconNote.vue?vue&type=template&id=d4e17c40"
import script from "./IconNote.vue?vue&type=script&lang=js"
export * from "./IconNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__